/* eslint-disable @typescript-eslint/naming-convention */
export enum ApiActionTypeEnum {
	COPYIN,
	CHECKIN,
	CHECKOUT
}
